import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import PageLoading from './PageLoading';
import { Typography } from './imports/muiImport';

const ModelLoading = ({ loadingStatus = false }) => {
  return (
    <div>
      <Modal
        open={loadingStatus}
        aria-labelledby="payment-loading"
        aria-describedby="payment-loading"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100vw',
            height: '100vh',
            bgcolor: 'background.paper',
          }}
        >
          <PageLoading />
          <Typography variant="body1" sx={{ mt: 2, textAlign: 'center' }}>
            Please wait, we are processing your payment securely...
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default ModelLoading;
